import { useEffect } from 'react';
import { ExternalLogger } from '@cld/unicorn-api';
import { State } from '../state';

export const useReportApplicationStartupError = ({ state, unicornExternalLogger }: { state: State; unicornExternalLogger: ExternalLogger }) => {
  const applicationError = state.applicationStatus === 'startupError' ? state.error : undefined;

  useEffect(() => {
    if (applicationError) {
      const error = new Error(applicationError.message);
      error.stack = applicationError.stack;

      unicornExternalLogger.error(error, applicationError.data);
    }
  }, [applicationError, unicornExternalLogger]);
};
